import * as React from 'react';
import { Svg } from '../svg';

function SvgEmailSent2({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#email-sent-2_svg__pattern0)" d="M0 0h80v80H0z" />
      <defs>
        <pattern
          id="email-sent-2_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#email-sent-2_svg__image0" transform="scale(.0125)" />
        </pattern>
        <image
          id="email-sent-2_svg__image0"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgEmailSent2);
export default ForwardRef;
